import { Pipe, PipeTransform } from '@angular/core';
import { toTitleCase } from '@nk/utils-lib';

@Pipe({
  standalone: true,
  name: 'titleCase',
})
export class TitleCasePipe implements PipeTransform {
  public transform(value: string): string {
    return toTitleCase(value);
  }
}
